<template>
	<div class="wrapper">
		<div class="header"><BaseHeader :title="'商家兑换详情'" /></div>
		<div class="content">
			<div class="banners" v-if="is_banner">
				<van-swipe :autoplay="3000" class="my-swipe" indicator-color="white">
					<van-swipe-item v-for="(image, index) in goods.banner" :key="index"><img v-lazy="image" /></van-swipe-item>
				</van-swipe>
			</div>
			<div class="con">
				<div class="con-1">
					<div class="title">
						<div class="item-title">{{ goods.name }}</div>
						<div class="item-tel">营业时间：{{shopInfo.open_time}}</div>
						<div class="item-tel" style="color: #AE8841;">{{goods.service_tag}}</div>
						<div class="item-tel">
							垂询电话：{{ shopInfo.tel }}
							<a :href="'tel:' + shopInfo.tel"><van-icon name="phone-o" size="25" color="#f20f20"></van-icon></a>
						</div>
						<div class="item-tel">
							适合人数：{{ goods.person_num }} 人
						</div>
						<div class="item-tel">
							综合销量：{{ goods.sales_num }}
						</div>
						<div class="item-tel" style="color: #F20C32;font-size: 14px;height: 30px;line-height: 30px;">
							<div style="font-weight: 550;">价格：￥{{ goods.price }}</div>
							<div style="color: #aaa;font-size: 10px;text-decoration:line-through;">￥{{ goods.high_price }}</div>
						</div>
						<div class="item-tel">
							赠送红包：<span style="color: #F20C32;">{{ goods.give_reds }}</span>
						</div>
					</div>
				</div>
				<div class="shop-address">
					<div class="location-img" @click="handleGoLocation(shopInfo.lat, shopInfo.lng, shopInfo.name, shopInfo.address)">
						<van-icon name="location-o" size="30" color="#f20f20" />
					</div>
					<div class="address" @click="handleGoLocation(shopInfo.lat, shopInfo.lng, shopInfo.name, shopInfo.address)">
						<p>{{ shopInfo.address }}</p>
					</div>
					<div class="tel">
						<!-- <a :href="'tel:' + shopInfo.tel">
				            <van-icon name="phone-o" size="25" color="#f20f20" ></van-icon>
				        </a> -->
						<div class="btn" @click="handleGoLocation(shopInfo.lat, shopInfo.lng, shopInfo.name, shopInfo.address)"><span>去这里</span></div>
					</div>
				</div>
				<div class="con-3">
					<van-tabs v-model="active">
						<van-tab title="详情介绍"><div class="goods-specific-info" v-html="goods.content"></div></van-tab>
					</van-tabs>
				</div>
			</div>
			<div class="my-buttom" @click="doBuy()">立即兑换</div>
		</div>
		<van-popup
		  v-model:show="buy_show"
		  closeable
		  round
		  close-icon="close"
		  position="bottom"
		  :style="{ height: '30%' }"
		>
		<div class="buy-div">
			<div class="buy-div-item">剩余数：<span style="color: #C6241A;">{{ goods.stock_num }}</span></div>
			<div class="buy-div-item">兑换数：{{num}}</div>
			<div class="buy-div-item">总价格：<span style="color: #C6241A;">￥{{ goods.price }}</span></div>
			<div class="buy-bottom" @click="buyNow()">确认兑换</div>
		</div>
		</van-popup>
	</div>
</template>

<script>
import BaseHeader from '../../components/BaseHeader';
import { getShopexchangeDetail } from '../../service/shopService';
import { Toast,Dialog } from 'vant';
import wx from 'weixin-js-sdk';
import { getWxSharService } from '../../service/weChatService';
import { isWeixinOrAlipayTools } from '../../util/tools';
import { getUrlParamsTools } from '../../util/tools';
import Vue from 'vue';
import { Swipe, SwipeItem, Lazyload, Tab, Tabs } from 'vant';
import { mapState, mapActions } from 'vuex';
import { shopGoodsWxPay } from '../../service/basicService';
import Cookies from 'js-cookie';
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Tab);
Vue.use(Tabs);
export default {
	name: 'newshopgoodsdetail',
	data() {
		return {
			shopId: 0,
			shopInfo: {},
			distance: '',
			banners: '',
			active: 0,
			goods: {},
			is_banner: true,
			isRefresh: 0,
			buy_show:false,
			num:1
		};
	},
	mounted() {
		this.isLogin();
		this.isRefresh = getUrlParamsTools('isrefresh');
		if(!this.isRefresh || this.isRefresh == 0){
			window.location.href = location.href + '?isrefresh=1';
		}
		this.shopId = this.$route.params.shopId;
		this.id = this.$route.params.id;
		this.getShopDetails();
		// this.share();
	},
	methods: {
		share() {
			console.log(this.$wx);
			const that = this;
			console.log(that.goods);
			getWxSharService(encodeURIComponent(location.href.split('#')[0])).then(result => {
				if (result.status === 1) {
					that.$wx.config({
						debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
						appId: result.datas.appId, // 公众号名称，由商户传入
						timestamp: result.datas.timestamp, // 时间戳，自1970年以来的秒数
						nonceStr: result.datas.nonceStr, // 随机串
						signature: result.datas.signature, // 微信签名
						jsApiList: ['updateTimelineShareData', 'updateAppMessageShareData'] // 必填，需要使用的JS接口列表
					});
					that.$wx.ready(function() {
						that.$wx.updateTimelineShareData({
							title: that.goods.name, // 分享标题
							link: 'https://www.shoudaole.cn/dist/#/shopexchangedetail/' + that.shopId + '/' + that.id, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
							imgUrl: that.goods.logo, // 分享图标
							success: function() {
								// Toast('分享成功');
							}
						});
						//分享给朋友
						that.$wx.updateAppMessageShareData({
							title: that.goods.name, // 分享标题
							desc: that.goods.service_tag, //分享描述
							link: 'https://www.shoudaole.cn/dist/#/shopexchangedetail/' + that.shopId + '/' + that.id, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
							imgUrl: that.goods.logo, // 分享图标
							success: function() {
								// Toast('分享成功');
							}
						});
					});
				} else {
					Toast(result.msg);
				}
			});
		},
		getShopDetails() {
			getShopexchangeDetail(this.shopId,this.id)
				.then(res => {
					if (res.status === 1) {
						this.goods = res.datas.goods;
						this.shopInfo = res.datas.shops;
						console.log(this.goods.banner.length);
						if(this.goods.banner.length == false){
							this.is_banner = false;
						}
						this.share();
					} else {
						Toast(res.msg);
					}
				})
				.catch(err => {
					console.log(err);
				});
		},
		goDetail(id) {
			console.log(id);
		},
		doBuy(){
			this.buy_show = true;
		},
		goOrder(){
			this.$router.push({
				name: 'shopgoodsorder'
			});
		},
		buyNow(){
			if(this.goods.stock_num - 1 < 0){
				Toast('剩余数量不足！');
				return false;
			}
			if(this.goods.price == 0){
				Toast('该服务无需兑换！可直接使用');
				return false;
			}
			var price = this.goods.price;
			var total = price;
			var openid = Cookies.get('o_id');
			console.log('openid',openid);
			console.log('id',this.id);
			var id = this.id;
			var num = this.num;
			// 发起微信支付d
			shopGoodsWxPay(id,num,this.shopId, this.userId, price, total, openid).then(res => {
				this.lock = false;
				if (res.status === 1) {
					if (price > 0) {
						WeixinJSBridge.invoke(
							'getBrandWCPayRequest',
							{
								appId: res.datas.appId, // 公众号名称，由商户传入
								timeStamp: res.datas.timeStamp, // 时间戳，自1970年以来的秒数
								nonceStr: res.datas.nonceStr, // 随机串
								package: res.datas.package,
								signType: res.datas.signType, // 微信签名方式：
								paySign: res.datas.paySign // 微信签名
							},
							result => {
								if (result.err_msg === 'get_brand_wcpay_request:ok') {
									this.lock = true;
									Toast('支付成功');
									this.goOrder();
								} else {
									Toast(result.err_msg);
								}
							}
						);
					} else {
						this.lock = true;
						Dialog.confirm({
							title: '提示',
							message: '支付成功'
						})
							.then(() => {
								this.$router.go(0);
							})
							.catch(() => {
								this.$router.go(0);
							});
					}
				}
			});
		},
		// 是否登录
		isLogin() {
			if (this.userId) {
				console.log('userId', this.userId);
			} else {
				this.$router.push({
					name: 'userLogin'
				});
				// Dialog.confirm({
				// 	title: '提示',
				// 	message: '您还未登录，是否前去登录'
				// })
				// 	.then(() => {
				// 		this.$router.push({
				// 			name: 'userLogin'
				// 		});
				// 	})
				// 	.catch(() => {});
			}
		},
		handleGoLocation(lat, lng, name, address) {
			console.log(address);
			const isWeixinOrAlipay = isWeixinOrAlipayTools();
			if (isWeixinOrAlipay === 'WeiXIN') {
				getWxSharService(encodeURIComponent(location.href.split('#')[0])).then(result => {
					if (result.status === 1) {
						wx.config({
							// debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
							appId: result.datas.appId, // 公众号名称，由商户传入
							timestamp: result.datas.timestamp, // 时间戳，自1970年以来的秒数
							nonceStr: result.datas.nonceStr, // 随机串
							signature: result.datas.signature, // 微信签名
							jsApiList: ['openLocation'] // 必填，需要使用的JS接口列表
						});
						wx.ready(function() {
							wx.openLocation({
								latitude: lat, //目的地latitude
								longitude: lng, //目的地longitude
								name: name,
								address: address,
								scale: 15 //地图缩放大小，可根据情况具体调整
							});
						});
					} else {
						Toast(result.msg);
					}
				});
			} else {
				// var backurl = "http://www.shoudaole.cn/dist/#/receiveShopList";
				var url =
					'https://apis.map.qq.com/tools/routeplan/eword=' +
					address +
					'&epointx=' +
					lat +
					'&epointy=' +
					lng +
					'&topbar=1?referer=收到乐&key=HUHBZ-EQY6K-CRRJD-AJITD-QSGJF-GNFE6&back=0';
				window.location.href = url;
				return false;
			}
		}
	},
	components: {
		BaseHeader
	},
	computed: {
		...mapState({
			userId: state => state.userInfo.userId,
			openId: state => state.userInfo.openId
		})
	}
};
</script>
<style scoped lang="scss">
.wrapper {
	overflow-x: hidden;
}
.shop-details {
	padding: 5px;
	box-sizing: border-box;
}
.shop-details img {
	width: 100%;
	height: 100%;
}
.banners {
	width: 100%;
}
.my-swipe .van-swipe-item {
	color: #fff;
	padding: 0;
	width: 100%;
}
.my-swipe img {
	width: 100%;
	height: 200px;
}
.con {
	width: 100%;
	margin-top: 5px;
	margin-bottom: 60px;
}
.con-1 {
	display: flex;
	background-color: #fff;
}
.logo {
	width: 25%;
	display: flex;
	justify-content: center;
	align-items: center;
}
.logo img {
	width: 80px;
	height: 80px;
	border-radius: 20px;
}
.title {
	width: 100%;
	padding: 10px;
	display: flex;
	flex-direction: column;
	line-height: 25px;
	justify-content: space-between;
}
.item-title {
	font-weight: 700;
	font-size: 15px;
}
.con-2 {
	display: flex;
	background-color: #fff;
	padding: 0 10px 10px 10px;
	justify-content: space-between;
}
.item-tel {
	font-size: 13px;
	display: flex;
	align-items: center;
	height: 25px;
}

.shop-address {
	font-size: 14px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 10px;
	box-sizing: border-box;
	background: #ffffff;
	margin: 5px 0;
	.location-img {
		flex: 10%;
	}
	.address {
		flex: 75%;
	}
	.tel {
		flex: 15%;
	}
	.btn {
		span {
			white-space: nowrap;
			background: #00BFFF;
			color: #ffffff;
			padding: 5px;
			box-sizing: border-box;
			border-radius: 20px;
			font-size: 12px;
		}
	}
}

.con-3 {
	background-color: #fff;
}
.new-goods-box {
	padding: 5px;
	background-color: #f6f4f4;
}
.new-goods {
	background-color: #fff;
	display: flex;
	padding: 10px;
	border-radius: 10px;
	margin-top: 5px;
}
.new-goods img {
	width: 80px;
	height: 80px;
	border-radius: 10px;
}

.new-goods-right {
	display: flex;
	flex-direction: column;
	padding-left: 10px;
	justify-content: space-between;
	font-weight: bold;
}
.my-buttom{
	width: 100%;
	background-color: #C6241A;
	color: #fff;
	text-align: center;
	font-weight: 900;
	font-size: 16px;
	height: 40px;
	line-height: 40px;
	position: fixed;
	bottom: 0;
}
.buy-div{
	width: 100%;
	height: 100%;
	padding: 40px;
	display: flex;
	flex-direction: column;
	font-size: 16px;
	font-weight: 700;
}
.buy-bottom{
	border-radius: 10px;
	width: 80%;
	background-color: #C6241A;
	color: #fff;
	text-align: center;
	font-weight: 900;
	font-size: 16px;
	height: 40px;
	line-height: 40px;
	position: fixed;
	bottom: 20px;
	margin-left: auto;
	margin-right: auto;
}
.buy-div-item{
	width: 80%;
	height: 40px;
	line-height: 40px;
	border-bottom: 1px solid #F6F4F4;
}
</style>

<style>
.goods-specific-info {
	background-color: #fff;
	width: 98%;
	padding-top: 10px;
	text-align: left;
	font-size: 16px;
	/* text-indent: 2em; */
	margin: auto;
}
.goods-specific-info img {
	width: 100% !important;
	height: 100% !important;
	/* margin-left: auto; */
	/* margin-right: auto; */
	display: block;
}

</style>
